// this file gets compiles by browserify
// please import your partial files here
// your partials can be in any other folder than 'json', 'my-source' or 'single'
// these folders are used for other tasks
// you can change the name of this file in the config.json
import 'lazysizes';
import 'svgxuse'

// custom scripts
import './components/helpers/_scrollTo'
import './functions/_removeOverlayer'
import './functions/_mobileMenu'
import './functions/_clipPathTest'
const baseUrl = footer

// vue dependencies
import Vue from 'vue';
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VuePagination from 'v-pagination'
import VueValidator from 'vue-validator'
import VueTouch from 'vue-touch'

// import VuePaginate from 'vue-paginate'
// matcher
import match from './components/matcher/matcher.vue'
import step1 from './components/matcher/matcher__step1.vue'
import matcherStep2 from './components/matcher/matcher__step2.vue'
import matcherStep3 from './components/matcher/matcher__step3.vue'
import matcherStep4 from './components/matcher/matcher__step4.vue'

// influencer stream
import influencerStream from './components/influencer/influencer__stream.vue'

// candidates Grid
import candidatesOverview from './components/candidates/candidatesOverview.vue'

// Vue Use Plugins or Components
Vue.use(VuePagination)
Vue.use(VueResource)
Vue.use(VueValidator)
Vue.use(VueTouch)
// disable warning because VueValidator ist printing some shit
Vue.config.warnExpressionErrors = false
Vue.http.options.emulateJSON = true;
// vue router
Vue.use(VueRouter)

Vue.directive('spinner', function(type) {
    var [type, url] = type;
    switch (type) {
        case 'iframe':
            this.el.onload = function() {
                this.vm.$set('loading', false)
            }.bind(this)

        case 'image':
            var img = new Image()
            img.src = url

            img.onload = function() {
                this.el.src = url
                this.vm.$set('loading', false)
            }.bind(this)
    }
})

var router = new VueRouter()

router.map({
    '/': {
        component: matcherStep2
    },
    '/matcher/step2/:one/:two/:three': {
        name: 'step2',
        component: matcherStep3
    },
    '/matcher/step3': {
        component: matcherStep4
    }
})

router.redirect({
    '*': '/'
})
var app = Vue.extend({})
router.start(app, '#game')


//basic vue App
import buttonNo from './components/layoutElements/svg/_buttonNo.vue'
var vm = new Vue({
    devtools: true,
    el: '#app',
    data() {
        return {
            baseUrl: baseUrl,
            influencerDreieckMore: false,
            influencerHenryMore: false
        }
    },
    components: {
        influencerStream,
        candidatesOverview,
        buttonNo
    }
});

// vue validator

Vue.validator('email', {
    message: 'E-Mail Adresse ung�ltig',
    check: function (val) { // define validator
        return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val)
    }
})

